// src/components/fashion/FashionPortfolio_container.js
import { connect } from "react-redux";
import FashionPortfolio from "./FashionPortfolio";
import { fetchAllFashionPhotos } from "../../actions/fashionphoto_actions";

const mapState = (state) => ({
  items: state.fashionphotos?.items || [],
  loading: state.fashionphotos?.loading || false,
  error: state.fashionphotos?.error || null,
});

const mapDispatch = (dispatch) => ({
  fetchAllFashionPhotos: () => dispatch(fetchAllFashionPhotos()),
});

export default connect(mapState, mapDispatch)(FashionPortfolio);
